import { ISO_FUEL_GRADE_MAP } from '@navstation-portal/fuel-specs/data-model/fuel-spec';
import { SelectOption } from '@navstation-portal/shared/data-model/common';

const ISO_GRADE_OPTIONS_MAP: Record<string, SelectOption[]> = Object.fromEntries(
  Object.entries(ISO_FUEL_GRADE_MAP).map(([key, grades]) => [
    key,
    grades.map((item) => ({ name: item.toLocaleUpperCase(), code: item })),
  ])
);

function getFuelTypeCode(value?: SelectOption): string | undefined {
  return (value as SelectOption | undefined)?.code as string | undefined;
}

export function getIsoGradeOptions(fuelType?: SelectOption): SelectOption[] {
  if (!fuelType) return [];
  const code = getFuelTypeCode(fuelType);

  return (code && ISO_GRADE_OPTIONS_MAP[code]) || [];
}
